import React from 'react'

export function useStatusOptions(translate) {
  return React.useMemo(
    () => [
      { key: 'bookings_status_pending', text: translate('PENDING'), value: 'PENDING' },
      { key: 'bookings_status_assigned', text: translate('ASSIGNED'), value: 'ASSIGNED' },
      { key: 'bookings_status_scheduled', text: translate('SCHEDULED'), value: 'SCHEDULED' },
      { key: 'bookings_status_completed', text: translate('COMPLETED'), value: 'COMPLETED' },
      { key: 'bookings_status_cancelled', text: translate('CANCELLED'), value: 'CANCELLED' },
    ],
    [translate]
  )
}
